var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hover-wrapper" }, [
    _c("div", { staticClass: "hover-notice" }, [
      _c("div", { staticClass: "hover-title" }, [
        _vm._v(_vm._s(_vm.$t("preview.t", { version: _vm.version })))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hover-content" }, [
        _vm._v(_vm._s(_vm.$t("preview.txt1")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hover-content" }, [
        _vm._v(_vm._s(_vm.$t("preview.txt2")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hover-content" }, [
        _vm._v(_vm._s(_vm.$t("preview.txt3")))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hover-content bold" }, [
        _vm._v(_vm._s(_vm.$t("preview.v", { version: _vm.version })))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }